import LocalStorageMixin from '@/shared/mixins/local-storage.mixin'
import Auth from '@/shared/mixins/auth.mixin'
import AuthService from '@/shared/services/auth.service'

export default {
  name: 'medico-validate',
  mixins: [
    LocalStorageMixin,
    Auth
  ],
  data: () => ({
    certValidate: {},
    urlParams: '',
    showDisable: false,
    AuthService: AuthService()
  }),
  async mounted () {
    this.urlParams = (new URL(window.location)).searchParams
    const qrCodeValidationCode = this.getQrCodeValidationCodeFromVidaasCallback(window.location.href, this.urlParams)
    const hasQrCodeValidationCode = Boolean(qrCodeValidationCode)
    if (hasQrCodeValidationCode) {
      const wasQrCodeSent = await this.sendQrCode(qrCodeValidationCode)

      if (!wasQrCodeSent) {
        return
      }
    }
    this.certValidate = await this.getValidateCertificate(hasQrCodeValidationCode)
    sessionStorage.setItem('certificateValidation', JSON.stringify(this.certValidate))
    this.redirect()
  },
  computed: {
    casesOfError () {
      if (!this.certValidate.usePtmSigner) {
        return
      }
      if (!this.certValidate.notUsePtmSigner && !this.certValidate.cert) {
        return {
          message: 'Ops! Parece que todas suas fontes exigem certificado digital e seu certificado está com algum erro ou pode estar revogado. Caso deseje, entre em contato com o time operações pelo chat no canto inferior direito da tela.',
          action: ''
        }
      }
      if (!this.certValidate.notUsePtmSigner && !this.certValidate.token) {
        return {
          message: 'Ops! Parece que todas suas fontes exigem certificado digital e seu token precisa ser validado.',
          action: 'validateQRCodeButton'
        }
      }
      if (this.certValidate.notUsePtmSigner && !this.certValidate.cert) {
        return {
          message: 'Ops! Parece que algumas de suas fontes exigem certificado digital e seu certificado está com algum erro ou pode estar revogado. Caso deseje, entre em contato com o time operações pelo chat no canto inferior direito da tela.',
          action: 'disableSourceButton'
        }
      }
      if (this.certValidate.notUsePtmSigner && !this.certValidate.token) {
        return {
          message: 'Ops! Parece que algumas de suas fontes exigem certificado digital e seu token expirou. Você pode desabilitar as fontes temporariamente para laudar nas demais ou validar o seu QrCode.',
          action: 'multiplesOptions'
        }
      }
    }
  },
  methods: {
    redirect() {
      const { usePtmSigner, cert, token, notUsePtmSigner } = this.certValidate
      const listExam = this.AuthService.getListExam()
      const isReviewer = sessionStorage.getItem('isReviewer')
      let redirectPath

      if (listExam) {
        redirectPath = '/medico/laudar-radio'
      } else if (this.AuthService.getOnlyReports()) {
        redirectPath = '/medico/laudar'
      } else if (isReviewer) {
        redirectPath = '/medico/revisar-laudo'
      }
      else {
        redirectPath = '/medico'
      }

      if ((usePtmSigner && cert && token) || !usePtmSigner) {
        sessionStorage.setItem('isValidatedPhysician', 'true')
        this.$router.push(redirectPath)
      } else if (usePtmSigner && cert && !token && !notUsePtmSigner) {
        this.validateQRCode()
      }
    },
    validateQRCode () {
      this.redirectToQrCodeValidation(this.certValidate.qrCodeUrl)
    },

    disableSource() {
      const listExam = this.AuthService.getListExam()
      this.disablePhysicianSource()
      sessionStorage.setItem('isValidatedPhysician', 'true')
      if (listExam) {
        this.$router.replace('/medico/laudar-radio')
      } else if (this.AuthService.getOnlyReports()) {
        this.$router.replace('/medico/laudar')
      } else {
        this.$router.replace('/medico')
      }
    },
    isErrorLoggedDontMatchUserScannedQrCode (error) {
      return (
        error.response &&
        error.response.status === 400 &&
        Array.isArray(error.response.data) &&
        error.response.data.length > 0 &&
        error.response.data[0].code === 'USER_LOGGED_DONT_MATCH_WITH_USER_SCANNED_QRCODE'
      )
    },
    getQrCodeValidationCodeFromVidaasCallback (callbackUrl, callbackSearchParams) {
      const qrCodeValidationCode = callbackSearchParams.get('code')

      if (qrCodeValidationCode !== null && qrCodeValidationCode !== '') {
        return qrCodeValidationCode
      }
      const callbackIdentifierWithCode = callbackSearchParams.get('a')

      if (callbackIdentifierWithCode !== null && callbackIdentifierWithCode !== '') {
        const callbackIdentifierCodeMatch = callbackIdentifierWithCode.match(/[?&]code=([^&]+)/)

        if (callbackIdentifierCodeMatch !== null) {
          const vidaasCallbackCode = callbackIdentifierCodeMatch[1]
          return decodeURIComponent(vidaasCallbackCode)
        }
      }

      const vidaasCallbackCodeMatch = callbackUrl.match(/[?&]code=([^&]+)/)

      if (vidaasCallbackCodeMatch === null) {
        return null
      }
      const vidaasCallbackCode = vidaasCallbackCodeMatch[1]
      return decodeURIComponent(vidaasCallbackCode)
    },
    async sendQrCode (qrCodeValidationCode) {
      if (qrCodeValidationCode) {
        try {
          await this.postSendQrCode(qrCodeValidationCode)
          return true
        } catch (error) {
          if (this.isErrorLoggedDontMatchUserScannedQrCode(error)) {
            this.handleIncorrectUserError()
          } else {
            console.error('Erro ao enviar QR code:', error)
          }
        }
      }
      return false
    },
    handleIncorrectUserError () {
      this.casesOfError = {
        message: 'O usuário que escaneou o QR code não corresponde ao usuário logado. Por favor, tente novamente com o usuário correto.',
        action: 'validateQRCodeButton'
      }
    },
    logout () {
      this.logoutUser()
    }
  }
}
